<template>
  <a-upload 
    accept="image/*"
    name="file"
    :showUploadList="false"
    :customRequest="handleChange"
    :before-upload="beforeUpload"
  >
    <div :id="id" class="upload-image-box">
      <UploadOutlined />
      <div v-if="limit?.max" class="count">
        {{ limit.count }} / {{ limit.max }}
      </div>
    </div>
  </a-upload>
</template>
<script>
import { UploadOutlined } from "@ant-design/icons-vue"
export default {
  components: { UploadOutlined },
  props: {
    imgFile: {
      type: Object,
      default: () => {}
    },
    id: String,
    limit: Object
  },
  methods: {
    beforeUpload(file) {
      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png"
      if (!isJpgOrPng) this.$message.error("您上传的图片格式不对")
      const isLt2M = +(file.size / 1024 / 1024).toFixed(2) < 2
      if (!isLt2M) this.$message.error("上传的图片最大限制为【2MB】")
      if (this.limit?.max && this.limit.count && this.limit.count === this.limit.max) {
        this.$message.error("上传的图片数量超过最大限定值了")
        return false
      }
      return isJpgOrPng && isLt2M
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    async handleChange(obj) {
      this.$emit('upload-image', {
        ...this.imgFile,
        img: URL.createObjectURL(obj.file),
        file: obj.file
      })
    }
  }
};
</script>
<style scoped lang="less">
.upload-image-box {
  width: 120px;
  height: 120px;
  border: 1px dashed #937373;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .anticon {
    font-size: 30px;
    color: #937373;
  }
  .count {
    margin-top: 10px;
  }
  &:hover {
    border-color: #007fff;
    .anticon, .count {
      color: #007fff;
    }
  }
}
</style>